module.exports = __webpack_public_path__ + "media/images/hero-background-14413c0fa89e886ed8748ca9d54b5607.jpg";